import React, { Fragment, useEffect, useState } from 'react';
import Link from 'next/link';
import Img from 'react-image';
import Text from 'reusecore/src/elements/Text';
import { Certified } from "../../../components/Ads/certified";
import { TagGroup, LabelTag } from '../../../components/TagGroup';
import { openModal } from '@redq/reuse-modal';
import { useAuth } from '../../../contexts/AuthProvider';
import { useUser } from '../../../contexts/UserContext';
import { Counter } from '../../../helpers/Counter';
import { analytics, db } from '../../../helpers/firebaseHelper';
import ShareModal from '../../ModalContainer/ShareModal';
import LoginModal from '../../ModalContainer/LoginModal';
import { CURRENCY } from '../../../Config';
import { useMutation } from '@apollo/client';
import { HANDLE_FAV } from '@core/ui/graphql/Mutations';
import Heading from 'reusecore/src/elements/Heading';
import Icon from '../../../components/Icon';
import Button from 'reusecore/src/elements/Button';
import { SEARCH_PAGE } from '@core/ui/navigation/constant';
import { dateFormat } from '../../../helpers/dateHelper';
import favIcon from '@core/ui/static/images/ico-fav-mini.svg';
import favIconFilled from '@core/ui/static/images/ico-fav-mini-filled.svg';
import shareIcon from '@core/ui/static/images/ico-share.svg';
import {
  DescriptionBlock,
  AlignCenterWrapper,
  ButtonWrapper,
  AdsExtraWrapper,
  AdsDescriptionWrapper,
  AdsInfoWrapper,
  AdsBottomWrapper,
  AdsShareWrapper,
  SubinfoWrapper,
  AdsDetailWrapper,
} from './description.style';
import MappingCategories from '../../../models/local/categories/MappingCategories';
import NumberFormat from 'react-number-format';
import { identity, pickBy } from 'lodash';
import icoLocation from '@core/ui/static/images/ico-location.svg';
import icoCalendar from '@core/ui/static/images/ico-calendar.svg';
import Report from '../../../components/Report';
import { useTranslation } from 'next-i18next';
import { slugify } from '../../../helpers/urlHandler';
import { truncateTitle } from '../../../helpers/textHelpers';

const Description = props => {
  const { postData } = props;

  const { updatedAt: publishTime = null } = postData;

  const { isLoggedIn } = useAuth();
  const { state: user } = useUser();
  const { t } = useTranslation();

  const { favorites: userFavList = [], userId } = user || {};

  const [btnLoading, setBtnLoading] = useState(false);
  const [userFav, setUserfav] = useState([]);

  const [handleFav] = useMutation(HANDLE_FAV, {
    variables: {
      fav: {
        id: userId,
        postId: postData.id,
      },
    },
  });

  const mappingCategoriesLocale = MappingCategories();

  let userNewFavList = [];

  const subInfos =
    postData && postData.subInfos ? pickBy(postData.subInfos, identity) : false;

  const isFavourite = (id, favList) => {
    const favItem = favList.filter(item => item === id);
    return favItem.length > 0;
  };

  const isFav = isFavourite(postData.id, userFav);

  const handleFavourite = async () => {
    setBtnLoading(true);
    if (isLoggedIn) {
      try {
        const data = await handleFav();

        userNewFavList =
          data &&
          data.data &&
          data.data.handleFav &&
          data.data.handleFav.data &&
          data.data.handleFav.data.length
            ? data.data.handleFav.data
            : [];

        if (userFav.length !== userNewFavList.length) {
          setUserfav(userNewFavList);
        }
        setBtnLoading(false);

        // analytics
        if (!isFav && typeof window !== 'undefined') {
          // Initialize the sharded counter.
          const favorites = new Counter(
            db.collection('ads').doc(postData.id),
            'stats.favorites'
          );

          // Increment the field "favorites" of the document
          favorites.incrementBy(1);

          if (analytics) {
            analytics.logEvent('add_to_wishlist', {
              currency: CURRENCY,
              items: [
                {
                  item_id: postData.sid,
                  item_name: postData.title,
                  item_category: postData.category,
                  price: postData.price,
                },
              ],
              value: postData.price,
            });
          }
        }
      } catch (error) {
        console.error('Error => ', error);
        setBtnLoading(false);
      }
    } else {
      setBtnLoading(false);
      // SHOW MODAL
      openModal({
        config: {
          disableDragging: false,
          minHeight: 'auto',
          width: 'auto',
          height: 'auto',
          enableResizing: true,
          transition: {
            tension: 150,
          },
        },
        springStyle: {
          backgroundColor: '#ffffff',
          overflowY: 'auto',
        },
        modalClass: 'loginModal',
        closeOnClickOutside: true,
        component: LoginModal,
        componentProps: {},
      });
    }
  };

  const adsCategory = (category, index) => {
    return (
      <div style={{ display: 'flex', marginLeft: 15 }}>
        <Icon name="md-pricetags" fontSize={21} color="#002F3F" mr={10} />
        <Link href={`/${SEARCH_PAGE}/${slugify(postData.category)}`}>
          <a key={index}>
            <span
              style={{
                fontSize: '15px',
                color: '#595959',
                fontWeight: 'normal',
                marginBottom: 0,
              }}
            >
              {t('category.' + postData.category)}
            </span>
          </a>
        </Link>
      </div>
    );
  };

  const handleShare = async () => {
    let isMobile = false;
    if (window.matchMedia('(any-hover: none)').matches) {
      // do sth
      isMobile = true;
    }

    // try to use
    if (isMobile && (navigator.canShare || navigator.share)) {
      try {
        const canonical = document.querySelector('link[rel=canonical]');
        await navigator
          .share({
            title: postData.title,
            text: postData.description,
            url: canonical ? canonical.href : document.location.href,
          })
          .then(() => {
            console.log('Shared successfully');
          })
          .catch(error => {
            console.error('error caught during sharing => ', error);
          });
      } catch (error) {
        // error or cancel
      }
      return;
    }

    openModal({
      config: {
        className: 'shareModal',
        width: 'auto',
        height: 'auto',
        enableResizing: false,
        disableDragging: true,
        transition: {
          tension: 150,
        },
      },
      withRnd: false,
      closeOnClickOutside: true,
      component: ShareModal,
      componentProps: {
        data: {
          image:
            postData.media && postData.media.length > 0
              ? postData.media[0]
              : '',
          price: postData.price,
          link: process.browser ? window.location.href : null,
          title: postData.title,
        },
      },
    });
  };

  useEffect(() => {
    //
    setUserfav(userFavList);
  }, [user]);

  return (
    <div>
      <AdsBottomWrapper>
        <AdsInfoWrapper>
          <div>
            <div style={{ alignItems: 'baseline', display: 'flex', paddingRight: 10 }}>
              <Certified certified={postData.certified} size={20} style={{
                color: '#00BCD4',
                marginRight: 5,
              }} />
              <Heading
                content={truncateTitle(postData.title)}
                as="h1"
                textAlign="left"
                fontSize={20}
                fontWeight={600}
                color="#0B2F3F"
                style={{ marginBottom: '0.625rem' }}
              />
            </div>
            {process.browser &&
              !!postData.price &&
              postData.price > 0 &&
              !postData.deleted && (
                <NumberFormat
                  value={postData.price}
                  displayType="text"
                  thousandSeparator=" "
                  renderText={value => (
                    <TagGroup>
                      <LabelTag
                        color="#00BCD4"
                        tagContent={`${value} ${CURRENCY} `}
                        style={{ fontSize: 18 }}
                      />
                    </TagGroup>
                  )}
                />
              )}
          </div>
          {!postData.deleted && (
            <div>
              <Button
                variant="outlined"
                className="outlineButton"
                isLoading={btnLoading}
                iconPosition="left"
                icon={
                  <Img
                    src={isFav ? favIconFilled : favIcon}
                    style={{
                      marginRight: '10px',
                      width: '18px',
                      height: '18px',
                    }}
                    alt=""
                  />
                }
                height={40}
                title={
                  isFav ? t('adsView.view.fav.del') : t('adsView.view.fav.add')
                }
                onClick={handleFavourite}
              />
            </div>
          )}
        </AdsInfoWrapper>
        <AdsDetailWrapper>
          {postData.town && (
            <Link href={`/${SEARCH_PAGE}/all?town=${postData.town.trim()}`}>
              <a
                style={{
                  display: 'flex',
                  flex: 1,
                  alignItems: 'center',
                }}
              >
                <img src={icoLocation} alt={t('adsView.view.locationAlt')} />
                <Text mb={0} ml={2} className="town" content={postData.town} />
              </a>
            </Link>
          )}
          {/*<AlignCenterWrapper>{adsCategory()}</AlignCenterWrapper>*/}

          {publishTime && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Fragment>
                <img src={icoCalendar} alt={t('adsView.view.dateAlt')} />
                <span
                  style={{ fontSize: '12px', color: '#595959', marginLeft: 8 }}
                >
                  {dateFormat(publishTime, t)}
                </span>
              </Fragment>
            </div>
          )}
        </AdsDetailWrapper>

        <AdsDescriptionWrapper>
          <Heading
            content={t('description')}
            fontSize={18}
            fontFamily="Poppins"
            fontWeight={600}
            color="#0B2F3F"
            mb={10}
            as="h2"
          />
          <AlignCenterWrapper>
            <DescriptionBlock>{postData.description}</DescriptionBlock>
          </AlignCenterWrapper>
        </AdsDescriptionWrapper>

        {subInfos && Object.keys(subInfos).length > 0 && (
          <AdsExtraWrapper>
            <Heading
              content={t('adsView.view.spec')}
              fontSize={18}
              fontFamily="Poppins"
              fontWeight={600}
              color="#0B2F3F"
              mb={20}
              as="h2"
            />
            <SubinfoWrapper>
              {Object.keys(subInfos).map(key => {
                if (mappingCategoriesLocale.hasOwnProperty(key)) {
                  return (
                    <div key={key}>
                      <div className="column">
                        <span className="desc-span-table label">
                          {mappingCategoriesLocale[key]['label']} :
                        </span>
                      </div>
                      <div className="column">
                        <span className="desc-span-table value">
                          {mappingCategoriesLocale[key]['skipTranslation']
                            ? subInfos[key]
                            : t('subCategory.' + subInfos[key])}
                          {mappingCategoriesLocale[key]['unite']}
                        </span>
                      </div>
                    </div>
                  );
                }
              })}
            </SubinfoWrapper>
          </AdsExtraWrapper>
        )}

        {!postData.deleted && (
          <AdsShareWrapper>
            <ButtonWrapper>
              <Button
                title={t('adsView.view.share.title')}
                variant="outlined"
                iconPosition="left"
                icon={
                  <Img
                    src={shareIcon}
                    style={{
                      marginRight: '10px',
                      height: 15,
                      marginTop: '-2px',
                    }}
                    alt=""
                  />
                }
                height={40}
                className="outlineButton"
                style={{
                  color: '#00BCD4',
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: '#e2e2e2',
                  height: 'auto',
                  padding: '15px',
                  textTransform: '',
                }}
                onClick={handleShare}
              />
              <Report ads={postData} userId={userId} />
            </ButtonWrapper>
          </AdsShareWrapper>
        )}
      </AdsBottomWrapper>
    </div>
  );
};

export default Description;
